import "../../css/RestaurantNav.css";
import { useNavigate } from "react-router-dom";

/**
 * Item for the RestaurantNav panel
 *
 * Props:
 * name: string
 * icon: react component
 * onClick: function
 * active: boolean
 * secondaryIcon: react component (optional)
 */
export const RestaurantNavItem = (props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    props.onClick(props.name);
    const restaurant = JSON.parse(localStorage.getItem("restaurant"));

    if (!restaurant || !restaurant.id || !restaurant.menu?.id) {
      console.error("Restaurant or Menu data is missing!");
      return;
    }

    const restaurantId = restaurant.id;
    const menuId = restaurant.menu.id;

    const routeMapping = {
      //dashboard: `/admin/restaurant/${restaurantId}/dashboard`,
      menu: `/admin/restaurant/${restaurantId}/menu/${menuId}`,
      reports: `/admin/restaurant/${restaurantId}/reports`,
      help: "/restaurant-admin/help",
      profile: `/admin/restaurant/${restaurantId}/profile`,
    };
    if (routeMapping[props.name]) {
      navigate(routeMapping[props.name]);
    }
  };

  const handleLogout = (event) => {
    event.stopPropagation(); // prevent the parent button's click handler
    localStorage.removeItem("authToken");
    localStorage.removeItem("restaurant");
    navigate("/");
  };

  return (
    <div className="RestaurantNavItem">
      <button
        className={`restaurant-nav-button ${
          props.active ? "restaurant-nav-button-active" : ""
        }`}
        onClick={handleClick}
      >
        <props.icon />
        <span className="item-text">{props.name}</span>
        {props.secondaryIcon && (
          <span
            className="RestaurantNavItem-secondary-icon"
            onClick={handleLogout}
          >
            <props.secondaryIcon />
          </span>
        )}
      </button>
    </div>
  );
};
